// Submits a hand-built form to Formie over ajax and returns { success, errors, redirectUrl }.
// redirectUrl is the confirmation page set on the form in Formie, or null.
// Pages are statically cached, so a fresh CSRF token is fetched first.
window.submitFormie = async function (form, config) {
    const tokens = await fetch(config.refreshUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    }).then((response) => response.json());

    const data = new FormData(form);
    data.set(tokens.csrf.param, tokens.csrf.token);

    const result = await fetch(config.actionUrl, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    }).then((response) => response.json());

    return {
        success: !!result.success,
        errors: Object.values(result.errors ?? {}).flat(),
        redirectUrl: result.redirectUrl || null,
    };
}
